import { createContext } from "react";
import { ImpersonationRequest } from "../functions/requests/impersonation";

export interface ImpersonationContext {
  currentImpersonation: ImpersonationRequest | null;
  isImpersonating: boolean;
  startImpersonation: (request: ImpersonationRequest) => Promise<void>;
  stopImpersonation: () => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const ImpersonationContext = createContext<ImpersonationContext>({
  currentImpersonation: null,
  isImpersonating: false,
  startImpersonation: async () => {},
  stopImpersonation: async () => {},
  loading: false,
  error: null,
}); 